<template>
  <section class="container">
    <section class="panel center-block">
      <div class="container-fluid">
        <h1 class="sep">Liste des questions du challenge<br /> {{TITRE}}</h1>
        <ul class="list__questions" v-for="(question,index) in QUESTIONS" :key="index">
          <li>
            <a href="javascript:void(0)" v-on:click="GoToQuestion(question.PrimaryKey)">
              <h3>Question {{++index}} - <em>{{question.Date}}</em></h3>
              <p>{{question.Intitule}}</p>
            </a>
          </li>
          <!--<li>
            <a href="#">
              <h3>Question 2 - <em>18/06/2019</em></h3>
              <p>Trouvez lequel de ces films osé n'existe pas</p>
            </a>
          </li>
          <li>
            <a href="#">
              <h3>Question 3 - <em>18/06/2019</em></h3>
              <p>Trouvez lequel de ces films osé n'existe pas</p>
            </a>
          </li>
          <li>
            <a href="#">
              <h3>Question 4 - <em>18/06/2019</em></h3>
              <p>Trouvez lequel de ces films osé n'existe pas</p>
            </a>
          </li>
          <li>
            <a href="#">
              <h3>Question 5 - <em>18/06/2019</em></h3>
              <p>Trouvez lequel de ces films osé n'existe pas</p>
            </a>
          </li>-->
        </ul>
      </div>
    </section><!-- PANEL -->
    <span class="panel-bottom"></span>
  </section><!-- CONTAINER FLUID-->
</template>
<script>
  import $ from 'jquery';
  import { Utility } from '../configs/configpaths';
  export default {
    data: function () {
      return {
        QUESTIONS: [],
        TITRE: ""
      };
    },

    mounted: function () {
      var _self = this;
      _self.$parent.GloablEvents();

      var CURRENT_USER = Utility.GetCurrent();
      var TOKEN = Utility.GetToken();
      if (!CURRENT_USER) {
        _self.$router.push('/');
      }
      var settings = {
        "async": false,
        "crossDomain": true,
        "url": _self.BASE_URL + "api/Question/AllQuestion",
        "data": {
          "challenge": parseInt(CURRENT_USER.Challenge),
          "participant": parseInt(CURRENT_USER.Id),
        },
        "method": "GET",
        "headers": {
          'Authorization': 'Bearer ' + TOKEN
        }
      };

      $.ajax(settings).done(function (response) {
        _self.QUESTIONS = response.Questions;
        _self.TITRE = response.TitreChallenge;
      }).fail(function () {
        _self.$router.push('/');

      });
    },
    methods: {
      GoToQuestion: function (id) {
        var _self = this;
        var CURRENT_USER = Utility.GetCurrent();
        var TOKEN = Utility.GetToken();
        if (!CURRENT_USER) {
          _self.$router.push('/');
        }
        var settings = {
          "async": false,
          "crossDomain": true,
          "url": _self.BASE_URL + "api/Question/CurrentQuestionType",
          "data": {
            "id": id
          },
          "method": "GET",
          "headers": {
            'Authorization': 'Bearer ' + TOKEN
          }
        };

        $.ajax(settings).done(function (reponse) {
          if (reponse === "ChoixUnique") { _self.$router.push('/QuestionType2/' + id); }
          if (reponse === "ChoixMultiple") { _self.$router.push('/QuestionType3/' + id); }
          if (reponse === "Numerique") { _self.$router.push('/QuestionType1/' + id); }
        }).fail(function () {
          _self.$router.push('/');

        });
      }
    }
  }
</script>
<style lang="scss" scoped>
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
